import { P as PubSub } from './pubsub-COBwjfLh.js';
import './notyf-DIw0RvBj.js';

class StickyAddToCart extends HTMLElement {
  #unsubscribe;
  #observer;
  #deferredObserveTimeout;

  connectedCallback() {
    this.#observeProductForm();
    this.#deferredObserveTimeout = setTimeout(() => this.#observeProductForm(), 0);

    this.#unsubscribe = PubSub.subscribe('variant:change', ({ id, data: { html } }) => {
      if (id !== this.dataset.productId) return;
      this.#handleVariantChange(html);
      // defer until product-form.js has replaced the DOM node
      setTimeout(() => this.#observeProductForm(), 0);
    });
  }

  disconnectedCallback() {
    this.#unsubscribe?.();
    this.#observer?.disconnect();
    this.#deferredObserveTimeout = clearTimeout(this.#deferredObserveTimeout);
  }

  /**
   * Handle variant changes.
   * @param {HTMLElement} html - The HTML to render.
   */
  #handleVariantChange(html) {
    const stickyAddToCart = html.querySelector('sticky-add-to-cart');
    if (!stickyAddToCart) return;
    this.innerHTML = stickyAddToCart.innerHTML;
  }

  /**
   * Observe the product form intersection.
   */
  #observeProductForm() {
    this.#observer?.disconnect();

    const productForm = document.querySelector('product-form');
    if (!productForm) return;

    this.#observer = new IntersectionObserver(([{ isIntersecting, boundingClientRect }]) => {
      // Only reveal once the form has been scrolled PAST (above the viewport top),
      // not while it's still below the fold — otherwise short viewports show it at load.
      const scrolledPast = !isIntersecting && boundingClientRect.top < 0;

      this.setAttribute('data-scrolled-past', String(scrolledPast));
    });

    this.#observer.observe(productForm);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
